import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Directive({
  selector: '[appNumberMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberMaskDirective),
      multi: true,
    },
  ],
})
export class NumberMaskDirective implements ControlValueAccessor {
  private onChange = (_: any) => {};
  private onTouched = () => {};

  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const value = this.el.value;

    // Remove tudo que não é número
    const rawValue = value.replace(/\D/g, '');

    if (rawValue.length === 0) {
      this.el.value = '';
      this.onChange('');
      return;
    }

    const intPart = rawValue.length > 2 ? rawValue.slice(0, -2) : '';
    const decimalPart = rawValue.slice(-2);

    const formatted = `${this.formatThousands(intPart)},${decimalPart}`;
    this.el.value = formatted;

    // Valor real como número com ponto (ex: 1234.56)
    this.onChange(`${parseInt(intPart, 10)}.${decimalPart}`);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value == null || value === '') {
      this.el.value = '';
      return;
    }

    const [intPart, decimalPart = '00'] = value.toString().split('.');
    const formatted = `${this.formatThousands(intPart)},${(decimalPart + '00').slice(0, 2)}`;
    this.el.value = formatted;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private formatThousands(value: string): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
}
